// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3yLj7","question":"Question_question__2omKa","description":"Question_description__3AMKZ"};